"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminCheckWaze = void 0;
const react_1 = __importDefault(require("react"));
const WazeAutoroute_1 = __importDefault(require("../../../services/WazeAutoroute/WazeAutoroute"));
const AdminCheckWaze = () => {
    return (react_1.default.createElement("main", { style: { maxWidth: 1200, margin: "0 auto", padding: 16 } },
        react_1.default.createElement("h1", null, "Trafic en direct \u2013 Autoroute de l\u2019Avenir (Dakar \u2194 AIBD \u2194 Thi\u00E8s)"),
        react_1.default.createElement("p", null, "Affichage Waze en temps r\u00E9el : accidents, ralentissements et travaux"),
        react_1.default.createElement(WazeAutoroute_1.default, null)));
};
exports.AdminCheckWaze = AdminCheckWaze;
